import {useQuery} from 'react-query'
import {
  api,
  queryClient,
  useMutationQuery,
} from 'base'
import {showSuccessNotification} from 'common/helpers'

export const useGetDefaultRequest = (uuid: string, enabled?: boolean) => {
  return useQuery(
    ['default-request-details', uuid],
    async () => {
      const {data} = await api.get(`/defaultRequest/${uuid}`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )
}
export const useUpdateDefaultRequest = (
  uuid: string,
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['update-default-request', uuid],
    async (payload) => {
      const {data} = await api.post(`/defaultRequest/${uuid}`, payload)
      return data
    },
    {
      onSuccess() {
        // queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('default-request-details')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Default request has been updated.')
        onClose()
      },
    }
  )
}
